import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const sessionLogs: ThemeApp['appComponents']['sessionLogs'] = {
  components: {
    sessionLogsHeader: {
      sessionLogsHeader: {
        headerIconButton: {
          color: themeUi.semantic.color.text.neutral700
        }
      },

      components: {
        clearButton: {
          clearButton: {
            color: themeUi.semantic.color.text.neutral700
          }
        }
      }
    }
  }
};
